import { AuthMethod } from '@infotech-soe/merps/types/session';
import React from 'react';
import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import { STORAGE_KEYS } from '../../../services/configuration/common';
import { AppState } from '../../../store/reducers/root';
import { isConnected } from '../../../store/selectors/connection';
import { getSessionState } from '../../../store/selectors/session';

import useUserGuideUrl from './hooks/useUserGuideUrl';
import LoginWrapper from './LoginWrapper';

const mapStateToProps = (state: AppState) => {
  const {
    requiredMethod,
    authenticated,
    authMethods,
    availableDSAgents,
    error,
    serverTimeZone,
  } = getSessionState(state);
  return {
    preferredAuthMethod: localStorage.getItem(
      STORAGE_KEYS.PREFERRED_AUTH_METHOD
    ) as AuthMethod,
    requiredMethod,
    authenticated,
    authMethods,
    serverTimeZone,
    dsAgents: availableDSAgents,
    hasError: error,
    connected: isConnected(state),
  };
};

const connector = connect(mapStateToProps);

export type LoginWrapperContainerProps = ConnectedProps<typeof connector> & {
  userGuideUrl?: string | null;
};

const ConnectedLoginWrapper = connector(LoginWrapper);

const LoginWrapperContainer: React.FC = () => {
  const userGuideUrl = useUserGuideUrl();

  return React.createElement(ConnectedLoginWrapper, { userGuideUrl });
};

export default LoginWrapperContainer;
